import * as __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__ from "../../variants/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__ from "../../variants/tv.js";
const buttonVariants = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3968a67e__.tv)({
    slots: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonSlots,
    variants: {
        type: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonTypeVariants,
        size: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonSizeVariants,
        emphasis: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonEmphasisVariants,
        fullWidth: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonFullWidthVariants,
        shadow: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonShadowVariants,
        disabled: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonDisabledVariants
    },
    compoundVariants: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonCompoundVariants,
    defaultVariants: __WEBPACK_EXTERNAL_MODULE__variants_index_js_e33e4e91__.buttonDefaultVariants
});
export { buttonVariants };
